export default __webpack_public_path__ + "static/media/gift-placeholder.69ce01ac.svg";